import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import AnswerAlternativeListItem from '../components/AnswerAlternativeListItem.js';
import Curve from '../components/Curve';
import BarChart from '../components/BarChart';
import ComponentToPrint from '../components/Diploma';
import lacapiProxy from '../libs/lacapi';
import ReactToPrint from 'react-to-print';

const ResultPage = props => {
	const [questionIndex, setQuestionIndex] = useState(0);
	const [heading, setHeading] = useState("Dina resultat");
	const [underLimit, setUnderLimit] = useState(props.user.results.crowdAverage.average - (props.user.results.crowdAverage.std * 2));
	const [aboveLimit, setAboveLimit] = useState(props.user.results.crowdAverage.average + (props.user.results.crowdAverage.std * 2));
	const [passed, setPassed] = useState(false);

	const componentRef = useRef();

	useEffect(() => {
		lacapiProxy.setCompleted(props.courseId);
		compareAverage();
		window.scrollTo(0, 0);

	}, []);

	useLayoutEffect(() => {
		if (!isNaN(questionIndex)) {
		}
	}, [questionIndex]);

	const showQuestion = event => {
		let i = parseInt(event.target.id, 10);
		setQuestionIndex(i);
	};


	const hideQuestion = () => {
		setQuestionIndex(null);
	};

	//TODO get from course details in luvit database
	const compareAverage = () => {
		console.log("undre gränsen: ", underLimit);
		console.log("övre gränsen: ", aboveLimit);
		console.log("user result: ", props.user.results.result);
		console.log("average result: ", props.user.results.crowdAverage.average);
		console.log("std: ", props.user.results.crowdAverage.std);

		if (props.user.results.result <= props.user.results.crowdAverage.average + (props.user.results.crowdAverage.std * 2) && props.user.results.result >= props.user.results.crowdAverage.average - (props.user.results.crowdAverage.std * 2)) {
			setHeading("Du skattar patientens symtom på samma vis som de flesta av dina kollegor.")
			setPassed(true);
		}
		if (props.user.results.result < (props.user.results.crowdAverage.average - (props.user.results.crowdAverage.std * 2))) {
			setHeading("Du underskattar patientens symtom, jämfört med de flesta av dina kollegor.")
		}
		if (props.user.results.result > (props.user.results.crowdAverage.average + (props.user.results.crowdAverage.std * 2))) {
			setHeading("Du överskattar patientens symtom, jämfört med de flesta av dina kollegor.")
		}
	}

	return (
		<div className="result-wrapper">

			<div className="white-background">
				<main>
					{!props.loaded ? (
						<div className="loader-container">
							<div className="dash uno"></div>
							<div className="dash dos"></div>
							<div className="dash tres"></div>
							<div className="dash cuatro"></div>
						</div>

					) : (
							props.user.hasResult ? (
								<div>
									<div>
										<div className="first-block">

											<h1>{heading}</h1>
											<div className="graph-div">
												<div className="aspect-ratio">

													<Curve mean={props.user.results.crowdAverage.average} std={props.user.results.crowdAverage.std} userResult={props.user.results.result} ></Curve>
												</div>

												<p>
													Grönt fält motsvarar normala resultat - två standarddeviationer kring medelvärdet.
												</p>
												<p>
													Om ditt resultat är maximalt två standarddeviationer högre eller lägre än det genomsnittliga resultatet blir du godkänd.
												</p>
												<p>
													Pilen <span className="arr" >&uarr;</span> visar ditt resultat.
												</p>
											</div>

											{passed ?
												<div>
													<ReactToPrint
														trigger={() => <a>Skriv ut diplom</a>}
														content={() => componentRef.current}
													/>
													<div style={{display:"none"}}>
														<ComponentToPrint courseTitle={props.courseTitle} user={props.user} aboveLimit={aboveLimit} underLimit={underLimit} ref={componentRef} />
													</div> 
												</div> : ""}
										</div>

										<div className="second-block">
											<h2>Jämför din skattning med andras</h2>
											<div className="flex-wrapper">
												<div className="flex-first">
													{props.questions.map((question, i) => {
														let thisQuestionIndex = i + 1;
														if (questionIndex == i) {
															return (
																<div key={i} id={i} className="accordion-expanded">
																	<div onClick={hideQuestion}>
																		<h3 className="accordion-heading" id={question.id}>{thisQuestionIndex + ". " + question.title}</h3>
																		<p className="question-text">
																			{question.text}
																		</p>
																		<div className="one-question">
																			<div className="question-answers">
																				<ul>
																					{question.answers.map((answer, i) => {
																						return (
																							<AnswerAlternativeListItem
																								key={i}
																								index={i}
																								id={answer.id}
																								answer={answer}
																								chosen={question.chosenAnswerIndex == i}
																							/>

																						);
																					})}
																				</ul>
																			</div>
																		</div>
																		<BarChart crowdAverage={props.user.results.crowdAverage} question={question} />
																	</div>
																</div>
															);
														} else {
															return (
																<div onClick={showQuestion} id={i} key={i} className="accordion-small">
																	<h3 className="accordion-heading" id={i}>{thisQuestionIndex + ". " + question.title}</h3>
																	<div id={i} className="result-number-div">
																		<span className="chosen-answer">{question.chosenAnswerIndex}</span>
																	</div>
																</div>
															);
														}
													})}
												</div>
											</div>
										</div>
									</div>
								</div>
							) : (
									//if user didnt fill out all the answers(came in to page with URL, deny access?)
									//länk tillbaka till kursen
									<div>
										Du måste göra klart utbildningen för att kunna se dina resultat
              				</div>
								)
						)}

					<nav className="btn-wrapper">
						<div className="btn-center-wrapper">
							<button className="btn" onClick={props.restart}>
								Upprepa utbildningen
							</button>
						</div>
					</nav>

				</main>
				<div className="pink-circle"></div>
			</div>
		</div>
	);
}

export default ResultPage;



// WEBPACK FOOTER //
// ./src/pages/ResultPage.js